"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgQuickTipWhite = function SvgQuickTipWhite(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 15a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.233 8.965.671-.286c-.187-.143-.297-.363-.297-.539 0-1.078 2.134-1.221 2.134-2.882 0-.946-.814-1.705-2.156-1.705-1.045 0-1.859.44-2.387 1.122l.55.594c.407-.539.924-.902 1.749-.902.869 0 1.298.473 1.298 1.023 0 1.166-1.991 1.287-1.991 2.684 0 .33.132.638.429.891Zm.231 2.145a.61.61 0 0 0 .605-.605.61.61 0 0 0-.605-.605.61.61 0 0 0-.605.605c0 .33.275.605.605.605Z",
    fill: "#919499"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgQuickTipWhite);
var _default = exports["default"] = Memo;